import template from './select-field.html';

function SelectFieldDirective($timeout) {
	'ngInject';

	const directive = {
		link,
		template,
		'restrict': 'E',
		'transclude': true,
		'scope': {
			'model': '=',
			// The class of the input
			'inputClass': '@inputClass',
			// The class of the label
			'labelClass': '@labelClass',
			// The placeholder of the input
			'labelText': '@labelText',
			// The placeholder of the input
			'myPlaceholder': '@myPlaceholder',
			'inputId': '@inputId'
		}
	};

	return directive;

	function link(scope) {
		let loseFocusTimeout = null;
		scope.onFocusLost = onFocusLost;
		scope.showResults = false;

		/**
		 * Function bind to the blur event on the input.
		 * When the input lose focus after a brief timeout the results will be cleared.
		 */
		function onFocusLost() {
			$timeout.cancel(loseFocusTimeout);

			loseFocusTimeout = $timeout(function() {
				scope.showResults = false;
			}, 200);
		}
	}
}

export default SelectFieldDirective;



/** WEBPACK FOOTER **
 ** ./client/components/select-field/select-field.directive.js
 **/